(function () {
  var modal = document.getElementById('large-order-modal');
  if (!modal) return;

  var threshold = parseInt(modal.dataset.threshold, 10);
  if (isNaN(threshold) || threshold < 1) threshold = 10;

  var overlay = document.getElementById('large-order-overlay');
  var closeBtn = document.getElementById('large-order-close');
  var continueBtn = document.getElementById('large-order-continue');
  var bodyEl = modal.querySelector('[data-large-order-body]');
  var bodyTpl = bodyEl ? bodyEl.getAttribute('data-template') : null;

  // #cart-form only exists on the cart page → checkout-interception context.
  var form = document.getElementById('cart-form');
  var checkoutBtn = form ? form.querySelector('button[name="checkout"]') : null;
  var bypass = false;
  var checkoutContext = false;

  function setCount(count) {
    if (bodyEl && bodyTpl) bodyEl.textContent = bodyTpl.replace('%COUNT%', count);
  }
  function setContinueLabel(key) {
    if (!continueBtn) return;
    var label = continueBtn.getAttribute('data-label-' + key);
    if (label) continueBtn.textContent = label;
  }
  function openModal() {
    modal.hidden = false;
    document.body.classList.add('is-large-order-open');
  }
  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('is-large-order-open');
  }

  // "Continuer" — on the cart page it resumes checkout; while browsing it just dismisses.
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      closeModal();
      if (checkoutContext && checkoutBtn) {
        bypass = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(checkoutBtn);
        } else {
          checkoutBtn.click();
        }
      }
    });
  }

  if (overlay) overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // Cart page: intercept the native checkout submit when total units >= threshold.
  // `cart_terms` (required) is validated by the browser before this fires, so the
  // modal only appears after the terms checkbox is accepted.
  if (form) {
    var totalUnits = function () {
      var sum = 0;
      var inputs = form.querySelectorAll('.product-card__qty-input');
      for (var i = 0; i < inputs.length; i++) {
        var v = parseInt(inputs[i].value, 10);
        if (!isNaN(v) && v > 0) sum += v;
      }
      return sum;
    };

    form.addEventListener('submit', function (e) {
      if (bypass) return;
      if (e.submitter && e.submitter !== checkoutBtn) return;
      var total = totalUnits();
      if (total < threshold) return;
      e.preventDefault();
      checkoutContext = true;
      setCount(total);
      setContinueLabel('checkout');
      openModal();
    });
  }

  // Public API — called by collection.js after an AJAX add-to-cart so the modal can
  // pop while the customer is still browsing a category page.
  window.QBPLargeOrder = {
    threshold: threshold,
    maybeShow: function (count) {
      count = parseInt(count, 10);
      if (isNaN(count) || count < threshold) return false;
      // Anti-nag: prompt at most once per session while browsing (checkout still always prompts).
      try {
        if (sessionStorage.getItem('qbpLargeOrderPrompted') === '1') return false;
      } catch (e) {}
      checkoutContext = false;
      setCount(count);
      setContinueLabel('browse');
      openModal();
      try { sessionStorage.setItem('qbpLargeOrderPrompted', '1'); } catch (e) {}
      return true;
    },
    open: openModal,
    close: closeModal
  };
})();
